import Service from '../AuthService';

const UrgencyHospitalType = {
  getAllUrgencyHospitalTypes() {
    return Service.get(`urgency-hospital-types`);
  }
};

export default UrgencyHospitalType;
